module.exports = __webpack_public_path__ + "static/img/crm_body_left_1.da11cf8e.png";